import styled from 'astroturf/react';

export const NewLine = styled.div`
  display: block;
  clear: both;
`;
